import styled from "styled-components"

export const Component = styled.footer`
  display: flex;
  flex-direction: column;
  margin-top: auto;
  background-color: ${({ theme }) => theme.colors.blue.darker};
`

export const Main = styled.div`
  display: flex;
  flex-direction: column;
  padding: 24px 0;
  gap: 48px;

  img {
    max-width: 124px;
    max-height: 124px;
    margin: auto;
  }
`

export const ColsArea = styled.div`
  display: flex;
  justify-content: space-between;
  gap: 64px;

  @media (max-width: ${({ theme }) => theme.bp.medium}px) {
    & > div:nth-child(1),
    & > div:nth-child(4) {
      display: none;
    }

    flex-direction: column;
  }
`

export const Col = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;
`

export const ColTitle = styled.div`
  font-size: 18px;
  font-weight: bold;
  color: ${({ theme }) => theme.colors.blue.main};
`

export const ColContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;

  a {
    text-decoration: none;
    font-size: 14px;
    cursor: pointer;
    color: ${({ theme }) => theme.colors.white.main};

    &:hover {
      text-decoration: underline;
    }
  }
`

export const CopyArea = styled.div`
  background-color: #121826;
  border-top: 1px solid rgba(255, 255, 255, 0.05);
  padding: 20px 24px;

  @media (max-width: ${({ theme }) => theme.bp.medium}px) {
    padding: 24px 20px;
  }
`

export const CopyInner = styled.div`
  max-width: 1120px;
  margin: 0 auto;
  display: flex;
  align-items: flex-start;
  gap: 14px;

  @media (max-width: ${({ theme }) => theme.bp.small}px) {
    gap: 12px;
  }
`

export const SecurityBadge = styled.span`
  flex-shrink: 0;
  width: 32px;
  height: 32px;
  border-radius: 8px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background: rgba(55, 195, 88, 0.14);
  color: #7ee0a0;
  margin-top: 1px;

  svg {
    display: block;
  }
`

export const CopyItem = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2px;
  min-width: 0;
`

export const CopyLabel = styled.span`
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: #7ee0a0;
  line-height: 1.2;
`

export const CopyText = styled.span`
  font-size: 12.5px;
  line-height: 1.55;
  color: rgba(255, 255, 255, 0.82);

  strong {
    color: #ffffff;
    font-weight: 600;
  }

  @media (max-width: ${({ theme }) => theme.bp.small}px) {
    font-size: 12px;
  }
`
